/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { Data, isDataLoaded, makeLoadedData } from '../../types/data-providers';
import { useAppData } from '.';
import { AppDataLoader } from '../../lib/app-data-loader';
import { OrganizationData } from '../../types';
export const useAppOrganizationData = (organizationId: string): Data<OrganizationData> => {
    const appData = useAppData();

    return React.useMemo(() => {
        const organizationData = AppDataLoader.getOrganization(appData, organizationId ? organizationId : undefined);
        if (!isDataLoaded(organizationData)) {
            return organizationData;
        }

        // if (!organizationData.value.locationIds.ok) {
        //     return makeErrorData(organizationData.value.locationIds.message || 'Unable to load locations');
        // }

        // const locationsData = AppDataLoader.getLocationsForLocationIds(
        //     appData,
        //     organizationData.value.locationIds.value
        // );

        // if (!isDataLoaded(locationsData)) {
        //     return locationsData;
        // }

        const result: Data<{
            id: string;
            name: string;
            address: string;
            //locations: Array<{ id: string; name: string; address: string | null }>;
        }> = makeLoadedData({
            id: organizationData.value.id,
            name: organizationData.value.name,
            address: organizationData.value.address,
           // locations: locationsData.value,
        });

        return result;
    }, [appData, organizationId]);
};
